(function(){
'use strict';
/* ===== Gymshark-style filter overrides (injected; overrides pureethical-fixes.css) ===== */
(function(){try{var s=document.createElement('style');s.id='pe-fd-gym';s.textContent='@media(max-width:999px){#filterBar .fb-pill[data-panel="sort"]{order:-1 !important}}@media(min-width:1000px){.pe-fd-n{display:none !important}.pe-fd-eyebrow{letter-spacing:.28em !important}.pe-fd-lbl{font-size:15px !important;font-weight:700 !important;letter-spacing:.02em !important;color:#111 !important}.pe-fd-sec-hd{padding:21px 40px !important}.pe-fd-sortblock{padding:24px 40px 12px !important}.pe-fd-sortblock .fp-inner{display:block !important;padding:0 !important}.pe-fd-sortblock .fp-title,.pe-fd-sortblock .fp-footer{display:none !important}.pe-fd-sortlbl{display:block;font-family:\'Outfit\',Inter,sans-serif;font-size:15px;font-weight:700;letter-spacing:.02em;text-transform:uppercase;color:#111;padding-bottom:10px}html body #filterPanels .fp-sort{display:flex !important;flex-direction:column !important;gap:1px !important}html body #filterPanels .fp-sort-chip{width:100% !important;justify-content:flex-start !important;border:none !important;border-radius:0 !important;background:none !important;box-shadow:none !important;padding:12px 0 !important;font-family:\'Outfit\',Inter,sans-serif !important;font-size:14px !important;font-weight:500 !important;letter-spacing:normal !important;text-transform:none !important;color:#3A3A3A !important;gap:13px !important}html body #filterPanels .fp-sort-chip:hover,html body #filterPanels .fp-sort-chip:active,html body #filterPanels .fp-sort-chip:focus{background:none !important;color:#000 !important;transform:none !important;box-shadow:none !important}html body #filterPanels .fp-sort-dot{width:19px !important;height:19px !important;min-width:19px !important;border:1.5px solid #C7C5BF !important;border-radius:50% !important;background:none !important;flex-shrink:0 !important;position:relative !important;box-shadow:none !important}html body #filterPanels .fp-sort-chip.active{color:#000 !important;font-weight:600 !important}html body #filterPanels .fp-sort-chip.active .fp-sort-dot{border-color:#0A0A0A !important;background:none !important}html body #filterPanels .fp-sort-chip.active .fp-sort-dot::after{content:\'\' !important;position:absolute !important;top:50% !important;left:50% !important;transform:translate(-50%,-50%) !important;width:9px !important;height:9px !important;border-radius:50% !important;background:#0A0A0A !important}html body #filterPanels .fp-size{display:grid !important;grid-template-columns:repeat(3,1fr) !important;gap:8px !important}html body #filterPanels .fp-size-pill{border-radius:3px !important;padding:15px 6px !important;font-size:12.5px !important;letter-spacing:.04em !important;min-width:0 !important;width:auto !important;border:1px solid #DCDAD4 !important}html body #filterPanels .fp-size-pill.active{border-color:#0A0A0A !important;background:#0A0A0A !important;color:#fff !important}.pe-fd-apply{height:40px !important;padding:0 26px !important;font-size:10px !important;letter-spacing:.14em !important;background:#2F6B46 !important;box-shadow:0 8px 20px -10px rgba(47,107,70,.55) !important}.pe-fd-apply:hover{background:#25583A !important;box-shadow:0 12px 24px -12px rgba(47,107,70,.6) !important}}';(document.head||document.documentElement).appendChild(s);}catch(e){}})();
/* Helpers */
/* security (2026-10-05): tags read from the URL may only contain letters, digits, spaces and - _ . ' & (they are inserted with textContent/setAttribute) */
function peSafeTag(t){t=String(t||'').slice(0,80);return /^[\p{L}\p{N} _.'&’-]+$/u.test(t)?t:'';}
function nt(t){ return (t||'').toLowerCase().replace(/\s+/g,'-').trim(); }
/* Collection base URL (no tag part) */
var collBase=(function(){
 var p=('/'+window.location.pathname.replace(/^\/+/,'')).split('/');
 var ci=p.indexOf('collections');
 return ci>=0?p.slice(0,ci+2).join('/'):('/'+window.location.pathname.replace(/^\/+/,''));
})();
/* State */
var pending=[];
var pendingSort=null;
var openP=null;
var pendingVendor=null;
var _catList=(function(){try{var d=document.getElementById('pe_cat_data');return d?JSON.parse(d.textContent):[];}catch(e){return[];}})();
var _genderTags=['men','women','bebe','crianca','kids','homem','mulher'];
/* Restore pending from URL path */
(function(){
 var p=('/'+window.location.pathname.replace(/^\/+/,'')).split('/');
 var ci=p.indexOf('collections');
 if(ci<0||ci+2>=p.length)return;
 p.slice(ci+2).join('/').split('+').forEach(function(t){if(!t)return;try{t=decodeURIComponent(t);}catch(e){return;}t=peSafeTag(t);if(t)pending.push(t);});
})();
/* Panel show/hide */
var fbar=document.getElementById('filterBar');
var fpanels=document.getElementById('filterPanels');
if(fpanels){ fpanels.style.setProperty('background-color','#17211A','important'); fpanels.style.setProperty('border-top','2px solid #E8805A','important'); }
/* Remove brand names from the Category list (brands belong in the Brand filter, not Category) */
(function(){try{
 var BRANDS=['boss','hugo-boss','tommy-hilfiger','calvin-klein','lotto','north-sails','norway-1963','alv-by-alviero-martini','alviero-martini','us-polo-assn','u.s.-polo-assn.'];
 var vend={};BRANDS.forEach(function(b){vend[b]=1;});
 var bpan=document.getElementById('panel-brand');
 if(bpan){bpan.querySelectorAll('.fp-brand-chip').forEach(function(b){var v=nt(b.getAttribute('data-vendor')||b.textContent);if(v)vend[v]=1;});}
 var cpan=document.getElementById('panel-cat');
 if(cpan){Array.prototype.slice.call(cpan.querySelectorAll('.fp-age-chip[data-tag]')).forEach(function(c){
  var t=nt(c.getAttribute('data-tag')),tx=nt(c.textContent);
  if(vend[t]||vend[tx]){if(c.parentNode)c.parentNode.removeChild(c);}
 });}
 _catList=_catList.filter(function(t){return !vend[nt(t)];});
}catch(e){}})();
function positionPanel(){
 if(!fpanels)return;
 if(window.innerWidth<=768){
 fpanels.style.cssText='position:fixed!important;left:0!important;right:0!important;bottom:0!important;top:auto!important;z-index:9000!important;border-radius:20px 20px 0 0!important;max-height:80vh!important;overflow-y:auto!important;background:#17211A!important;border-top:2px solid #E8805A!important;';
 } else {
 fpanels.style.cssText='background:#17211A!important;border-top:2px solid #E8805A!important;';
 }
}
function closeAll(){
 if(fpanels)fpanels.classList.remove('open');
 document.querySelectorAll('.fp-inner').forEach(function(p){
 p.classList.remove('fp-active');
 p.style.setProperty('display','none','important');
 });
 document.querySelectorAll('.fb-pill').forEach(function(b){b.classList.remove('open');});
 openP=null;
}
document.querySelectorAll('.fb-pill[data-panel]').forEach(function(btn){
 btn.addEventListener('click',function(e){
 e.stopPropagation();
 var pid=btn.getAttribute('data-panel');
 if(openP===pid){closeAll();return;}
 closeAll();
 var panel=document.getElementById('panel-'+pid);
 if(!panel)return;
 positionPanel();
 panel.classList.add('fp-active');
 panel.style.removeProperty('display');
 fpanels.classList.add('open');
 btn.classList.add('open');
 openP=pid;
 panel.querySelectorAll('[data-tag]').forEach(function(el){el.classList.toggle('active',pending.indexOf(el.dataset.tag)>-1);});
 panel.querySelectorAll('.fp-brand-chip').forEach(function(c){c.classList.toggle('active',c.dataset.vendor===pendingVendor);});
 });
});
window.addEventListener('resize',function(){if(openP)positionPanel();});
document.addEventListener('click',function(e){if(fbar&&!fbar.contains(e.target)&&(!fpanels||!fpanels.contains(e.target)))closeAll();});
/* updateUI: badges + active pills */
function updateUI(){
 var pEl=document.getElementById('activeFilters');
 if(pEl){
 pEl.innerHTML='';
 pending.forEach(function(t){
 var s=document.createElement('span');
 s.className='filter-pill';
 /* security (2026-10-05): build the pill with DOM APIs, never innerHTML, because tags come from the URL */
 s.appendChild(document.createTextNode(nt(t).replace(/-/g,' ')));
 var sx=document.createElement('button');sx.className='filter-pill-x';sx.setAttribute('data-tag',t);sx.setAttribute('aria-label',(window.PE_T?window.PE_T('remove_x','Remove'):'Remove'));sx.textContent='\u00d7';
 s.appendChild(sx);
 pEl.appendChild(s);
 });
 }
 document.querySelectorAll('.fp-age-chip[data-tag],.fp-size-pill[data-tag],.fp-colour-item[data-tag]').forEach(function(el){el.classList.toggle('active',pending.indexOf(el.dataset.tag)>-1);});
 document.querySelectorAll('.fb-pill[data-panel]').forEach(function(btn){
 var pid=btn.getAttribute('data-panel');
 var panel=document.getElementById('panel-'+pid);
 var count=0;
 if(panel)panel.querySelectorAll('[data-tag]').forEach(function(el){if(el.dataset.tag&&pending.indexOf(el.dataset.tag)>-1)count++;});
 if(pid==='sort'&&pendingSort)count=1;
 var badge=btn.querySelector('.fb-pill-badge');
 btn.classList.toggle('has-active',count>0);
 if(badge)badge.textContent=count>0?String(count):'';
 });
 document.querySelectorAll('.fb-pill[data-panel="brand"]').forEach(function(btn){
  var badge=btn.querySelector('.fb-pill-badge');
  btn.classList.toggle('has-active',!!pendingVendor);
  if(badge)badge.textContent=pendingVendor?'1':'';
 });
}
updateUI();
/* toggleTag */
function toggleTag(tag){var i=pending.indexOf(tag);if(i>-1)pending.splice(i,1);else pending.push(tag);updateUI();}
/* toggleGender: single-select */
function toggleGender(tag){
 var already=pending.indexOf(tag)>-1;
 pending=pending.filter(function(t){return _genderTags.indexOf(nt(t))<0;});
 if(!already)pending.push(tag);
 document.querySelectorAll('.fp-gender-chip').forEach(function(c){c.classList.toggle('active',c.dataset.tag===tag&&!already);});
 updateUI();
}
/* buildUrl */
function buildUrl(){
 var base=pendingSort?pendingSort.split('?')[0]:collBase;
 var qp=pendingSort?'?sort_by='+pendingSort.split('sort_by=')[1]:'';
 var tags=pending.map(function(t){return nt(t);});
 var url=tags.length?base+'/'+tags.join('+')+qp:base+qp;
 if(pendingVendor){url+=(url.indexOf('?')>=0?'&':'?')+'vendor='+encodeURIComponent(pendingVendor);}
 return url;
}
/* OR FILTER */
function getCardTags(card){
 var raw=(card.dataset.tags||card.dataset.tag||'').trim();
 if(!raw)return [];
 var arr=raw.indexOf('|')>=0?raw.split('|'):raw.split(',');
 return arr.map(function(t){return t.trim();}).filter(Boolean);
}
function runOrFilter(orTags){
 var grid=document.getElementById('collGrid');
 if(!grid)return 0;
 var cards=grid.querySelectorAll('.product-card');
 var shown=0;
 cards.forEach(function(card){
 var ct=getCardTags(card);
 var ok=orTags.some(function(orTag){return ct.indexOf(orTag)>=0||ct.some(function(ct2){return nt(ct2)===orTag;});});
 card.style.display=ok?'':'none';
 if(ok)shown++;
 });
 var cEl=document.querySelector('.fb-count,.coll-count');
 if(cEl)cEl.textContent=shown+' products';
 return shown;
}
(function(){
 var qs=window.location.search;
 if(qs.indexOf('_or=')>=0){
 var m=qs.match(/[?&]_or=([^&]+)/);
 if(!m)return;
 var orRaw='';try{orRaw=decodeURIComponent(m[1]);}catch(e){return;}var orTags=orRaw.split('|').map(nt).map(peSafeTag).filter(Boolean);
 if(!orTags.length)return;
 orTags.forEach(function(t){if(pending.indexOf(t)<0)pending.push(t);});
 function run(){
 var n=runOrFilter(orTags);
 var cards=document.querySelectorAll('#collGrid .product-card');
 if(n===0&&cards.length===0){setTimeout(run,200);return;}
 updateUI();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);
 else run();
 }
})();
(function(){
 var m=window.location.search.match(/[?&]vendor=([^&]+)/);
 if(m){try{pendingVendor=decodeURIComponent(m[1]);}catch(e){pendingVendor=null;}if(pendingVendor)updateUI();}
})();
/* Interaction delegation */
document.addEventListener('click',function(e){
 /* Brand chip */
 var bi=e.target.closest('.fp-brand-chip[data-vendor]');
 if(bi){e.preventDefault();pendingVendor=pendingVendor===bi.dataset.vendor?null:bi.dataset.vendor;document.querySelectorAll('.fp-brand-chip').forEach(function(c){c.classList.toggle('active',c.dataset.vendor===pendingVendor);});updateUI();return;}
 /* Gender chip (single-select) */
 var gi=e.target.closest('[data-tag].fp-gender-chip');
 if(gi){e.preventDefault();toggleGender(gi.dataset.tag);return;}
 /* Other tag chips */
 var fi=e.target.closest('[data-tag].fp-age-chip,[data-tag].fp-size-pill,[data-tag].fp-colour-item');
 if(fi){e.preventDefault();toggleTag(fi.dataset.tag);return;}
 /* Sort chip */
 var si=e.target.closest('.fp-sort-chip[data-sort]');
 if(si){
 var sp=document.getElementById('panel-sort');
 if(sp)sp.querySelectorAll('.fp-sort-chip').forEach(function(b){b.classList.remove('active');});
 si.classList.add('active');pendingSort=si.dataset.sort;return;
 }
 function applyPending(){
 var catNorm=(_catList||[]).map(nt);
 var catP=pending.filter(function(t){return catNorm.indexOf(nt(t))>=0;});
 var othP=pending.filter(function(t){return catNorm.indexOf(nt(t))<0;});
 if(catP.length>1){
 var orStr=catP.map(nt).join('|');
 var othStr=othP.length>0?'/'+othP.map(nt).join('+'):'';
 var sortStr=pendingSort?'&sort_by='+pendingSort.split('sort_by=')[1]:'';
 var vStr=pendingVendor?'&vendor='+encodeURIComponent(pendingVendor):'';
 window.location.href=collBase+othStr+'?_or='+encodeURIComponent(orStr)+sortStr+vStr;
 } else if(pending.length===0&&pendingSort){
 window.location.href=pendingSort;
 } else {
 window.location.href=buildUrl();
 }
 closeAll();
 }
 if(e.target.closest('[data-apply]')){applyPending();return;}
 var cp=e.target.closest('[data-clear]');
 if(cp){
 var pid2=cp.dataset.clear;
 var catNorm2=(_catList||[]).map(nt);
 if(pid2==='cat'){
 pending=pending.filter(function(t){return catNorm2.indexOf(nt(t))<0;});
 } else if(pid2==='gender'){
 pending=pending.filter(function(t){return _genderTags.indexOf(nt(t))<0;});
 document.querySelectorAll('.fp-gender-chip').forEach(function(c){c.classList.remove('active');});
 } else if(pid2==='brand'){
 pendingVendor=null;document.querySelectorAll('.fp-brand-chip').forEach(function(c){c.classList.remove('active');});
 } else {
 var cpan=document.getElementById('panel-'+pid2);
 if(cpan)cpan.querySelectorAll('[data-tag]').forEach(function(el){
 var i=pending.indexOf(el.dataset.tag);if(i>-1)pending.splice(i,1);
 el.classList.remove('active');
 });
 }
 if(pid2==='sort'){pendingSort=null;var sp2=document.getElementById('panel-sort');if(sp2)sp2.querySelectorAll('.fp-sort-chip').forEach(function(b){b.classList.remove('active');});}
 updateUI();
 applyPending();return;
 }
 var px=e.target.closest('.filter-pill-x[data-tag]');
 if(px){toggleTag(px.dataset.tag);return;}
});
/* Grid toggle */
var grid=document.getElementById('collGrid');
document.querySelectorAll('.fb-view-btn[data-cols]').forEach(function(btn){btn.addEventListener('click',function(){document.querySelectorAll('.fb-view-btn').forEach(function(b){b.classList.remove('active');});btn.classList.add('active');if(grid)grid.setAttribute('data-cols',btn.dataset.cols);try{localStorage.setItem('pe_gc',btn.dataset.cols);}catch(ex){}});});
try{var sc=localStorage.getItem('pe_gc');if(sc&&grid){grid.setAttribute('data-cols',sc);document.querySelectorAll('.fb-view-btn[data-cols]').forEach(function(b){b.classList.toggle('active',b.dataset.cols===sc);});}}catch(ex){}
document.querySelectorAll('.fb-view-btn[data-mob-cols]').forEach(function(btn){btn.addEventListener('click',function(){document.querySelectorAll('.fb-view-btn[data-mob-cols]').forEach(function(b){b.classList.remove('active');});btn.classList.add('active');var cols=btn.getAttribute('data-mob-cols');if(grid){grid.classList.remove('mobile-1col','mobile-2col');if(cols==='1')grid.classList.add('mobile-1col');else if(cols==='2')grid.classList.add('mobile-2col');}});});
/* Load more */
(function(){var btn=document.getElementById('lmBtn');if(!btn||!grid)return;var busy=false;function go(e){if(e&&e.preventDefault)e.preventDefault();if(busy||!btn.dataset.next)return;busy=true;btn.textContent='...';fetch(btn.dataset.next).then(function(r){return r.text();}).then(function(html){var doc=new DOMParser().parseFromString(html,'text/html');var ng=doc.getElementById('collGrid');if(ng)ng.querySelectorAll('.product-card').forEach(function(c){grid.appendChild(c);});var nb=doc.getElementById('lmBtn');if(nb){btn.dataset.next=nb.dataset.next;btn.innerHTML=nb.innerHTML;}else{document.getElementById('lmWrap').innerHTML='<p class="lm-done">'+(window.PE_T?window.PE_T('all_loaded','All products loaded'):'All products loaded')+'</p>';}if(window.syncWishlistUI)syncWishlistUI();busy=false;}).catch(function(){btn.textContent=(window.PE_T?window.PE_T('load_more','Load more'):'Load more');busy=false;});}btn.addEventListener('click',go);new IntersectionObserver(function(e){if(e[0].isIntersecting)go();},{rootMargin:'300px'}).observe(btn);})();
})();

/* ===== PE Desktop Vertical Filter Drawer (white premium) - desktop only ===== */
(function(){
 if(!window.matchMedia||!window.matchMedia('(min-width:1000px)').matches) return;
 var bar=document.getElementById('filterBar'), panels=document.getElementById('filterPanels');
 if(!bar||!panels||document.querySelector('.pe-fd-trigger')) return;
 /* clean category chips: drop brands, sale-XX tags, duplicates */
 try{
  var catWrap=document.querySelector('#panel-cat .fp-cat-chips');
  if(catWrap){
   var vendors={};
   document.querySelectorAll('#panel-brand .fp-brand-chip[data-vendor]').forEach(function(v){vendors[(v.getAttribute('data-vendor')||'').toLowerCase().trim()]=1;});
   var seen={};
   Array.prototype.slice.call(catWrap.querySelectorAll('.fp-age-chip')).forEach(function(ch){
    var t=(ch.getAttribute('data-tag')||'').toLowerCase().trim();
    var txt=(ch.textContent||'').toLowerCase().trim();
    var isSale=/^sale[-\s]?\d+/.test(t)||/^sale[-\s]?\d+/.test(txt);
    var isVendor=vendors[txt]||vendors[t];
    if(isSale||isVendor||seen[txt]){ if(ch.parentNode)ch.parentNode.removeChild(ch); } else { seen[txt]=1; }
   });
  }
 }catch(e){}
 var LABELS={cat:'Categoria',gender:'Genero',size:'Tamanho',colour:'Cor',brand:'Marca',sort:'Ordenar'};
 var ORDER=['cat','gender','size','colour','brand'];
 var FACET='.fp-age-chip,.fp-size-pill,.fp-colour-item,.fp-brand-chip,.fp-gender-chip,.fp-quick-link,.fp-sort-chip';
 var COUNTABLE='.fp-age-chip,.fp-size-pill,.fp-colour-item,.fp-brand-chip,.fp-gender-chip';
 panels.style.setProperty('background','#FFFFFF','important');
 panels.classList.add('pe-drawer');
 panels.style.setProperty('transform','translateX(-102%)','important');
 panels.style.setProperty('pointer-events','auto','important');
 var head=document.createElement('div');head.className='pe-fd-head';head.innerHTML='<div class="pe-fd-head-txt"><span class="pe-fd-eyebrow">'+(window.PE_T?window.PE_T('refine','Afinar seleção'):'Afinar seleção')+'</span><span class="pe-fd-title">'+(window.PE_T?window.PE_T('filters','Filtros'):'Filtros')+'</span></div><button class="pe-fd-close" type="button" aria-label="'+(window.PE_T?window.PE_T('close_x','Fechar'):'Fechar')+'">&times;</button>';
 var scroll=document.createElement('div');scroll.className='pe-fd-scroll';
 var foot=document.createElement('div');foot.className='pe-fd-foot';foot.innerHTML='<button class="pe-fd-clear" type="button">Limpar tudo</button><button class="pe-fd-apply" type="button" data-apply>Ver resultados</button>';
 var sortPan=document.getElementById('panel-sort');if(sortPan&&sortPan.querySelector('.fp-sort-chip')){sortPan.classList.add('fp-active');sortPan.style.setProperty('display','block','important');var sblk=document.createElement('div');sblk.className='pe-fd-sortblock';var slbl=document.createElement('span');slbl.className='pe-fd-sortlbl';slbl.textContent=(window.PE_T?window.PE_T('sort_by','Ordenar por'):'Ordenar por');sblk.appendChild(slbl);sblk.appendChild(sortPan);scroll.appendChild(sblk);}
 ORDER.forEach(function(pid){var pan=document.getElementById('panel-'+pid);if(!pan)return;if(!pan.querySelector(FACET))return;pan.classList.add('fp-active');pan.style.setProperty('display','block','important');var n=pan.querySelectorAll(COUNTABLE).length;var sec=document.createElement('div');sec.className='pe-fd-sec';var hd=document.createElement('button');hd.type='button';hd.className='pe-fd-sec-hd';hd.innerHTML='<span class="pe-fd-lbl">'+(LABELS[pid]||pid)+'</span><span class="pe-fd-meta">'+(n>0?'<span class="pe-fd-n">'+n+'</span>':'')+'<span class="pe-fd-ico" aria-hidden="true"></span></span>';var bd=document.createElement('div');bd.className='pe-fd-sec-body';bd.appendChild(pan);sec.appendChild(hd);sec.appendChild(bd);scroll.appendChild(sec);hd.addEventListener('click',function(){var wasOpen=sec.classList.contains('pe-open');var opened=scroll.querySelectorAll('.pe-fd-sec.pe-open');for(var i=0;i<opened.length;i++){opened[i].classList.remove('pe-open');}if(!wasOpen){sec.classList.add('pe-open');}});});
 panels.innerHTML='';panels.appendChild(head);panels.appendChild(scroll);panels.appendChild(foot);
 var first=scroll.querySelector('.pe-fd-sec');if(first)first.classList.add('pe-open');
 document.body.appendChild(panels);
 var backdrop=document.createElement('div');backdrop.id='pe-fd-bd';document.body.appendChild(backdrop);
 var trig=document.createElement('button');trig.type='button';trig.className='pe-fd-trigger';trig.innerHTML='<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 5h18M6 12h12M10 19h4"/></svg> Filtrar';
 var sc2=bar.querySelector('.filter-bar-scroll');if(sc2)sc2.insertBefore(trig,sc2.firstChild);
 function openD(){var h=document.querySelector('.site-header');var top=h?Math.max(0,Math.round(h.getBoundingClientRect().bottom)):152;panels.style.top=top+'px';backdrop.style.top=top+'px';panels.style.setProperty('transform','translateX(0)','important');panels.style.setProperty('pointer-events','auto','important');panels.classList.add('pe-open');backdrop.classList.add('pe-open');panels.querySelectorAll('.fp-inner').forEach(function(p){p.classList.add('fp-active');p.style.setProperty('display','block','important');});}
 function closeD(){panels.style.setProperty('transform','translateX(-102%)','important');panels.classList.remove('pe-open');backdrop.classList.remove('pe-open');}
 trig.addEventListener('click',function(e){e.stopPropagation();openD();});
 head.querySelector('.pe-fd-close').addEventListener('click',closeD);
 backdrop.addEventListener('click',closeD);
 document.addEventListener('keydown',function(e){if(e.key==='Escape')closeD();});
 foot.querySelector('.pe-fd-apply').addEventListener('click',function(){setTimeout(closeD,60);});
 foot.querySelector('.pe-fd-clear').addEventListener('click',function(){var p=('/'+window.location.pathname.replace(/^\/+/,'')).split('/collections/');window.location.href=p[0]+'/collections/'+(p[1]||'').split('/')[0].split('?')[0];});
})();

/* ===== PE effective-price sort — accounts for tag-based discounts (desktop + mobile) =====
   v30 Fase 4: DESLIGADO. Descarregava ate 41 paginas seguidas (~1000 produtos, ~19 MB no telemovel) para
   reordenar por descontos de etiqueta que nao existem (0 produtos com preco anterior). A ordenacao por
   preco da Shopify ja vem certa do servidor. Para reativar no futuro, mudar PE_EFF_SORT para true. */
(function(){
 var PE_EFF_SORT=false;
 if(!PE_EFF_SORT) return;
 var m=window.location.search.match(/[?&]sort_by=(price-ascending|price-descending)/);
 if(!m) return;
 var dir=m[1]==='price-ascending'?1:-1;
 var grid=document.getElementById('collGrid');
 if(!grid) return;
 function peEff(card){
  var v=parseInt(card.getAttribute('data-eff'),10);
  return isNaN(v)?0:v;
 }
 function sortNow(){
  var cards=Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
  cards.sort(function(a,b){ return (peEff(a)-peEff(b))*dir; });
  cards.forEach(function(c){ grid.appendChild(c); });
  grid.style.opacity='';
 }
 function run(){
  grid.style.opacity='.55';
  var wrap=document.getElementById('lmWrap');
  var btn=document.getElementById('lmBtn');
  var next=btn?btn.dataset.next:'';
  if(wrap&&wrap.parentNode) wrap.parentNode.removeChild(wrap); /* detach built-in load-more */
  var guard=0;
  function step(url){
   if(!url||guard>40){ sortNow(); if(window.syncWishlistUI){try{syncWishlistUI();}catch(e){}} return; }
   guard++;
   fetch(url).then(function(r){return r.text();}).then(function(html){
    var doc=new DOMParser().parseFromString(html,'text/html');
    var ng=doc.getElementById('collGrid');
    if(ng){ ng.querySelectorAll('.product-card').forEach(function(c){ grid.appendChild(c); }); }
    var nb=doc.getElementById('lmBtn');
    step(nb?nb.dataset.next:'');
   }).catch(function(){ sortNow(); if(window.syncWishlistUI){try{syncWishlistUI();}catch(e){}} });
  }
  if(next){ step(next); } else { sortNow(); }
 }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run);
 else run();
})();
